/**
 * 上传前校验：大小与扩展名与 Runtime 服务端上限对齐，避免大文件进入 FileReader。
 */

export const UPLOAD_LIMITS = {
  bp: {
    maxBytes: 8 * 1024 * 1024,
    maxMb: 8,
    extensions: [
      '.txt',
      '.md',
      '.markdown',
      '.docx',
      '.pdf',
      '.png',
      '.jpg',
      '.jpeg',
      '.webp',
      '.bmp',
    ],
    label: 'BP',
  },
  contract: {
    maxBytes: 12 * 1024 * 1024,
    maxMb: 12,
    extensions: ['.docx', '.pdf', '.txt', '.md', '.markdown'],
    label: '合同',
  },
  dd: {
    maxBytes: 12 * 1024 * 1024,
    maxMb: 12,
    extensions: ['.docx', '.pdf', '.txt', '.md', '.markdown'],
    label: '尽调材料',
  },
};

export function getUploadFileExtension(fileName) {
  const match = String(fileName || '')
    .toLowerCase()
    .match(/(\.[a-z0-9]+)$/);
  return match ? match[1] : '';
}

export function assertUploadFile(file, kind = 'bp') {
  if (!file) {
    throw new Error('请先选择文件。');
  }
  const limit = UPLOAD_LIMITS[kind] || UPLOAD_LIMITS.bp;
  const ext = getUploadFileExtension(file.name);
  if (!ext || !limit.extensions.includes(ext)) {
    throw new Error(
      `${limit.label}不支持该文件类型「${ext || '无扩展名'}」。允许：${limit.extensions.join('、')}`,
    );
  }
  if (typeof file.size === 'number' && file.size > limit.maxBytes) {
    const sizeMb = (file.size / (1024 * 1024)).toFixed(1);
    throw new Error(
      `${limit.label}文件过大（${sizeMb}MB），上限 ${limit.maxMb}MB。请压缩或拆分后重试。`,
    );
  }
}

export function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || '');
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(new Error('读取文件失败'));
    reader.readAsDataURL(file);
  });
}

export async function readBpFilePayload(file, kind = 'bp') {
  assertUploadFile(file, kind);
  const lower = file.name.toLowerCase();
  const isText = /\.(txt|md|markdown|csv|json|html?|xml)$/i.test(lower);
  if (isText) {
    const textContent = await file.text();
    return {
      fileName: file.name,
      textContent,
      mimeType: file.type || 'text/plain',
    };
  }
  const contentBase64 = await readFileAsBase64(file);
  return {
    fileName: file.name,
    contentBase64,
    mimeType: file.type || 'application/octet-stream',
  };
}
